export default "__VITE_ASSET__CnoL2HkE__"